<template>
  <v-layout
    style="height: calc(100% - 64px);"
    fill-height
    column
  >
    <Loading :visible="isLoading" />

    <transition name="fade">
      <v-layout v-if="isSuccess" column>
        <v-layout v-if="items.length" class="pa-2" wrap align-content-start>
          <v-flex
            v-for="(item, index) in items"
            :key="`voucher-${index}`"
            lg3
            md6
            xs12
          >
            <VoucherCard
              :data="item"
              :active="Number(voucherActive) === Number(item.employee.id)"
              @openDrawer="openDrawer"
            />
          </v-flex>
        </v-layout>

        <EmptyState v-else type="phone">
          <span v-html="emptyStateText" />
        </EmptyState>
      </v-layout>
    </transition>

    <Error :visible="isFailed" @tryAgain="handleReloadData" />

    <GlobalDrawer
      :show="globalDrawer.visibility"
      :drawerType="globalDrawer.type"
      :data="globalDrawer.data"
      :filters="globalDrawer.filters"
      @close="closeDrawer"
    />
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import globalDrawerMixin from 'mixins/globalDrawer'
import { isValidObject, objectToArray } from 'corp-front-vue-commons/src/utils/functions'
import { formatNumber } from 'utils/functions'
import Loading from 'components/Table/Loading'
import Error from 'components/Table/Error'
import EmptyState from 'components/EmptyState'
import VoucherCard from './VoucherCard'
import GlobalDrawer from 'components/GlobalDrawer'

export default {
  name: 'Table',
  props: {
    items: {
      type: Array,
      required: true
    },
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    },
    drawerVisibility: {
      type: Boolean
    },
    cellPhone: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    globalDrawerMixin
  ],
  components: {
    Loading,
    Error,
    EmptyState,
    VoucherCard,
    GlobalDrawer
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims
    }),

    routeId () {
      const { id } = this.$route.params
      return id ? Number(id) : null
    },

    totalVisible () {
      return window.innerWidth <= 420 ? 5 : 7
    },

    firstItemNumber () {
      const { currentPage, itemsPerPage } = this.pagination
      const calc = (currentPage * itemsPerPage) - itemsPerPage + 1
      const item = currentPage === 1 ? 1 : calc
      return formatNumber(item)
    },

    lastItemNumber () {
      const { currentPage, itemsPerPage, totalElements } = this.pagination
      const calc = currentPage * itemsPerPage
      const item = calc > totalElements ? totalElements : calc
      return formatNumber(item)
    },

    emptyStateText () {
      return !this.cellPhone
        ? this.$t(`${this.namespace}.emptyStateMessage`)
        : this.$t(`${this.namespace}.phoneNotFoundMessage`)
    },

    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.SearchPhonePage',
      selectedItem: null,
      voucherActive: null,
      globalDrawer: {
        visibility: false,
        type: '',
        data: {}
      }
    }
  },
  methods: {
    isValidObject (val) {
      return isValidObject(val)
    },

    setVoucherActive (data) {
      this.voucherActive = data && data.employee && data.employee.id
        ? data.employee.id
        : null
    },

    removeVoucherActive (data) {
      this.voucherActive = null
    },

    openDrawer (data) {
      this.setVoucherActive(data)
      this.openGlobalDrawer({
        type: 'voucher',
        data
      })
    },

    closeDrawer () {
      this.removeVoucherActive()
      this.closeGlobalDrawer()
    },

    companyStatus (companyStatus) {
      const status = {
        enabled: this.$t('Views.CompanyDetailsPage.enabled'),
        ativa: this.$t('Views.CompanyDetailsPage.enabled'),
        disabled: this.$t('Views.CompanyDetailsPage.disable'),
        fraudSuspect: this.$t('Views.CompanyDetailsPage.fraudSuspect'),
        offboarding: this.$t('Views.CompanyDetailsPage.offboarding'),
        pendingEmail: this.$t('Views.CompanyDetailsPage.pendingEmail'),
        empresaemsememail: this.$t('Views.CompanyDetailsPage.pendingEmail'),
        onboarding: this.$t('Views.CompanyDetailsPage.pendingEmail')
      }

      return status[companyStatus.toLowerCase().replace(/\s/g, '')] || null
    },

    getCategoryData (category) {
      const cat = objectToArray(this.$t('Common.ridesCategoriesList')).find(item => item.value === category)
      if (cat) return cat.text
    },

    getCategories (categories) {
      const cat = categories.map(category => this.getCategoryData(category)).sort()
      const arr1 = cat.filter((item, index) => index === 0 || index === 1)
      const arr2 = cat.slice(2, cat.length - 1)
      const arr3 = cat[cat.length - 1]
      const br = arr1.length > 1 ? '<br>' : ''
      return cat.length > 1
        ? `${arr1.join(', ')},${br} ${arr2.join(', ')} e ${arr3}`
        : cat.toString()
    },

    handlePage (page) {
      this.closeDrawer()
      this.$emit('handlePage', page)
    },

    handleReloadData () {
      this.$emit('reloadData')
    }
  },
  watch: {
    selectedCompany () {
      this.closeDrawer()
    },

    drawerVisibility () {
      this.closeDrawer()
    }
  }
}
</script>
